"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var utils_1 = require("../../utils");
/** HOC to render children depending on device width */
var Responsive = function (_a) {
    var children = _a.children, showIn = _a.showIn, rest = __rest(_a, ["children", "showIn"]);
    var widthProps = React.useMemo(function () { return widthFactory(showIn); }, [showIn]);
    return (React.createElement(semantic_ui_react_1.Responsive, __assign({ as: React.Fragment, fireOnMount: true }, widthProps, rest), children));
};
var widthFactory = function (showIn) {
    if (!Array.isArray(showIn) && typeof showIn === 'string') {
        return deviceWidthMap[showIn];
    }
    var widths = [];
    if (showIn.includes(utils_1.Device.Mobile)) {
        widths.push(deviceWidthMap[utils_1.Device.Mobile]);
    }
    if (showIn.includes(utils_1.Device.Tablet)) {
        widths.push(deviceWidthMap[utils_1.Device.Tablet]);
    }
    if (showIn.includes(utils_1.Device.Desktop)) {
        widths.push(deviceWidthMap[utils_1.Device.Desktop]);
    }
    var maxWidth = (widths.some(function (w) { return Number(w.maxWidth); }) &&
        !showIn.includes(utils_1.Device.Desktop) && Math.max.apply(Math, widths.filter(function (w) { return w.maxWidth; }).map(function (w) { return Number(w.maxWidth); }))) ||
        undefined;
    var minWidth = (widths.some(function (w) { return Number(w.minWidth); }) &&
        !showIn.includes(utils_1.Device.Mobile) && Math.min.apply(Math, widths.filter(function (w) { return w.minWidth; }).map(function (w) { return Number(w.minWidth); }))) ||
        undefined;
    return __assign(__assign({}, (maxWidth && { maxWidth: maxWidth })), (minWidth && { minWidth: minWidth }));
};
var deviceWidthMap = (_a = {},
    _a[utils_1.Device.Mobile] = {
        maxWidth: semantic_ui_react_1.Responsive.onlyMobile.maxWidth,
    },
    _a[utils_1.Device.Tablet] = {
        maxWidth: semantic_ui_react_1.Responsive.onlyTablet.maxWidth,
        minWidth: semantic_ui_react_1.Responsive.onlyTablet.minWidth,
    },
    _a[utils_1.Device.Desktop] = {
        minWidth: semantic_ui_react_1.Responsive.onlyComputer.minWidth,
    },
    _a);
exports.default = React.memo(Responsive);
//# sourceMappingURL=index.js.map